import React from 'react'
import { Skeleton } from '@bbl-digital/snorre-v2'
import { Wrapper } from './styles'

interface IProps {
  inputHeight?: string
  hideLabel?: boolean
}

// Created for Input snorre component
const SkeletonInput: React.FC<IProps> = ({
  inputHeight = '40px',
  hideLabel,
}) => {
  return (
    <Wrapper inputHeight={inputHeight} hideLabel={hideLabel}>
      {!hideLabel && <Skeleton width={'40%'}></Skeleton>}
      <Skeleton
        variant="rectangle"
        borderRadius={'5px'}
        height={'100%'}
        width={'100%'}
      />
    </Wrapper>
  )
}

export default SkeletonInput
